import React, { useState } from "react";

import { useLocation } from "react-router";
import styled from "styled-components";
import { HeadingLabel } from "@sisuwellness/ui/src/components/Labels";

import PageLayout from "components/PageLayout";
import ImproveLaunch from "./ImproveLaunch";
import BreadCrumbs from "views/BreadCrumbs";
import { Flex, Text } from "rebass";
import ImproveCard from "./ImproveCard";
import { IMPROVE_DATA, RETIRED_DESTINATIONS } from "./ImproveCardData";
import FlexWithGap from "components/Flex";
import { useTranslation } from "react-i18next";

const StyledText = styled(Text)`
    color: ${props => props.theme.colours.hpPrimaryPurple.hex};
`;

const StyledGrid = styled(Flex)`
    display: grid;
    row-gap: 24px;
    grid-template-columns: repeat(auto-fill, minmax(346px, 1fr));
`;

const ImproveView = () => {
    const { t } = useTranslation();
    const [destination, setDestination] = useState(null);

    const { search = "" } = useLocation();
    const searchParams = new URLSearchParams(search);
    const wants = searchParams.get("wants");
    const provider = searchParams.get("provider");

    if (wants && !RETIRED_DESTINATIONS.includes(wants)) {
        return <ImproveLaunch wants={wants} provider={provider} replace />;
    }

    if (destination) {
        window.scrollTo(0, 0);
        return <ImproveLaunch wants={destination} />;
    }

    return (
        <PageLayout>
            <BreadCrumbs />
            <FlexWithGap fd="column" gap="16px" mb={["24px", "32px"]}>
                <HeadingLabel fontSize={["28px", "34px"]} fontWeight="500">
                    {t("members_portal_web.views.improve.heading")}
                </HeadingLabel>
                <StyledText fontSize={["13px", "15px"]}>{t("members_portal_web.views.improve.description")}</StyledText>
            </FlexWithGap>
            <StyledGrid flexWrap="wrap">
                {IMPROVE_DATA.map(card => (
                    <ImproveCard
                        key={card.title}
                        title={card.title}
                        text={card.text}
                        image={card.image}
                        handleClick={setDestination}
                        link={card.link}
                        isPremOnlyCard={card.isPremOnlyCard}
                        isCoreOnlyCard={card.isCoreOnlyCard}
                    />
                ))}
            </StyledGrid>
        </PageLayout>
    );
};

export default ImproveView;
